// Small toggle switch. Wraps base-ui's Switch with the project's
// design tokens. Used in place of native checkboxes for boolean
// settings — the OS-default look is the #1 piece of "weird chrome"
// in the UI and this fixes it everywhere it gets adopted.

import { Switch as BaseSwitch } from "@base-ui-components/react/switch";

interface SwitchProps {
	checked: boolean;
	onCheckedChange: (next: boolean) => void;
	disabled?: boolean;
	"aria-label"?: string;
}

export function Switch({
	checked,
	onCheckedChange,
	disabled,
	"aria-label": ariaLabel,
}: SwitchProps) {
	return (
		<BaseSwitch.Root
			checked={checked}
			onCheckedChange={onCheckedChange}
			disabled={disabled}
			aria-label={ariaLabel}
			className="
				relative inline-flex h-[18px] w-[30px] shrink-0 cursor-pointer items-center
				rounded-full border border-[var(--color-border)]
				bg-[var(--color-surface-solid)]
				transition-colors duration-150
				focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/20
				disabled:opacity-50 disabled:cursor-not-allowed
				data-[checked]:bg-[var(--color-text)]
				data-[checked]:border-[var(--color-text)]
			"
		>
			<BaseSwitch.Thumb
				className="
					block h-[12px] w-[12px] rounded-full
					bg-[var(--color-text)]
					translate-x-[2px]
					transition-transform duration-150
					data-[checked]:translate-x-[14px]
					data-[checked]:bg-[var(--color-bg)]
				"
			/>
		</BaseSwitch.Root>
	);
}
